import createIcon from '../../createIcon';

/**
 * @component @name TwoWheeler
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMTFDMTkuODIgMTEgMTkuNjQgMTEuMDMgMTkuNDcgMTEuMDVMMTcuNDEgOUgyMFY2TDE2LjI4IDcuODZMMTMuNDEgNUg5VjdIMTIuNTlMMTQuNTkgOUgxMUw3IDExTDUgOUgwVjExSDRDMS43OSAxMSAwIDEyLjc5IDAgMTVDMCAxNy4yMSAxLjc5IDE5IDQgMTlDNi4yMSAxOSA4IDE3LjIxIDggMTVMMTAgMTdIMTNMMTYuNDkgMTAuOUwxNy41IDExLjkxQzE2LjU5IDEyLjY0IDE2IDEzLjc1IDE2IDE1QzE2IDE3LjIxIDE3Ljc5IDE5IDIwIDE5QzIyLjIxIDE5IDI0IDE3LjIxIDI0IDE1QzI0IDEyLjc5IDIyLjIxIDExIDIwIDExWk00IDE3QzIuOSAxNyAyIDE2LjEgMiAxNUMyIDEzLjkgMi45IDEzIDQgMTNDNS4xIDEzIDYgMTMuOSA2IDE1QzYgMTYuMSA1LjEgMTcgNCAxN1pNMjAgMTdDMTguOSAxNyAxOCAxNi4xIDE4IDE1QzE4IDEzLjkgMTguOSAxMyAyMCAxM0MyMS4xIDEzIDIyIDEzLjkgMjIgMTVDMjIgMTYuMSAyMS4xIDE3IDIwIDE3WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TwoWheeler = createIcon('TwoWheeler', [
  [
    'path',
    {
      d: 'M20 11C19.82 11 19.64 11.03 19.47 11.05L17.41 9H20V6L16.28 7.86L13.41 5H9V7H12.59L14.59 9H11L7 11L5 9H0V11H4C1.79 11 0 12.79 0 15C0 17.21 1.79 19 4 19C6.21 19 8 17.21 8 15L10 17H13L16.49 10.9L17.5 11.91C16.59 12.64 16 13.75 16 15C16 17.21 17.79 19 20 19C22.21 19 24 17.21 24 15C24 12.79 22.21 11 20 11ZM4 17C2.9 17 2 16.1 2 15C2 13.9 2.9 13 4 13C5.1 13 6 13.9 6 15C6 16.1 5.1 17 4 17ZM20 17C18.9 17 18 16.1 18 15C18 13.9 18.9 13 20 13C21.1 13 22 13.9 22 15C22 16.1 21.1 17 20 17Z',
      key: '1l3ygl',
    },
  ],
]);

export default TwoWheeler;
